import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function FalcoBorn() {
  const dateTexts = ['1851年'];
  const title = 'カメリアファルコS.E.A.任命式典';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/sea_main.jpg'
  const description = (
    <>
      <a href='/camellia-falco'>
        {'カメリアファルコ'}
      </a>
      {'が女性初のS.E.A.メンバーとして認定される。任命式典では'}
      <a href='/vitale-robustelli'>
        {'ヴィラーレ・ロブステリ'}
      </a>
      {'が認定書の授与を行い、'}
      <a href='/jason-chandler'>
        {'ジェイソン・チャンドラー'}
      </a>
      {'が書記を担当する。'}
    </>
  );
  const quoteDomain = 'Disney';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default FalcoBorn;
